"use client";

import React, { ReactNode, useState, useEffect } from "react";
import { ImageKit } from "@aph/ui-lib-humanx";
import { usePathname } from "next/navigation";
import NextLink from "next/link";
import Icon247 from "$/icons/icon_m247.svg";
import IconArticle from "$/icons/icon_article.svg";
import IconMenu from "$/icons/icon_menu.svg";
import IconHome from "$/icons/icon_mHome.svg";
import IconVideo from "$/icons/icon_mvideo.svg";
import Menu from "@/components/Menu";
import routes from "@/helpers/router";
import { NEXT_PUBLIC_MOM_BABY_BASE_PATH } from "@/libs/constants/auth";
import styles from "./BottomNavigation.module.scss";

interface bottomNavigation {
  iconUrl?: string;
  label?: string;
  targetUrl?: string;
  iconVector?: ReactNode;
}
interface BottomNavigationProps {
  bottomNavigation?: bottomNavigation[];
  serverPathname?: string;
  isUserFromApp?: boolean;
}

const BottomNavigation: React.FC<BottomNavigationProps> = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const pathname: string = usePathname();

  useEffect(() => {
    if (isMenuOpen) setIsMenuOpen(false);
  }, [pathname]);

  const toggleMenu: () => void = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const bottomNavigation = [
    {
      iconVector: <Icon247 height={20} width={30} className={`${styles.icon} ${styles.noColor}`} />,
      label: "Apollo",
      targetUrl: props?.isUserFromApp ? "apollopatients://TabBar?name=HOME" : "https://www.apollo247.com/",
    },
    {
      iconVector: <IconHome height={20} width={20} className={styles.icon} />,
      label: "Home",
      targetUrl: routes.home,
    },
    {
      iconVector: <IconMenu height={20} width={20} className={styles.icon} />,
      label: "Menu",
      targetUrl: "",
      onClick: (e) => {
        e?.preventDefault();
        toggleMenu();
      },
    },
    {
      iconVector: <IconArticle height={20} width={20} className={styles.icon} />,
      label: "Articles",
      targetUrl: routes.resourcesListing(undefined, "articles"),
    },
    {
      iconVector: <IconVideo height={20} width={20} className={styles.icon} />,
      label: "Videos",
      targetUrl: routes.resourcesListing(undefined, "video"),
    },
  ];

  return (
    <>
      <Menu isOpen={isMenuOpen} />
      {!!bottomNavigation?.length && (
        <div className={styles.bottomNaviRoot}>
          <ul className={styles.listRoot}>
            {bottomNavigation.map((item: any, index) => {
              const { label, targetUrl, iconVector, iconUrl } = item;
              const replaceRegex = new RegExp(`(${NEXT_PUBLIC_MOM_BABY_BASE_PATH})\/?|^(\/*)?|(\/*)?$`, "g");
              const isActive =
                label === "Menu"
                  ? isMenuOpen
                  : pathname?.replaceAll(replaceRegex, "") === targetUrl.replaceAll(replaceRegex, "");

              return (
                <li className={`${styles.list}`} key={`nav_${index}`}>
                  <NextLink
                    prefetch={false}
                    href={targetUrl || "#"}
                    onClick={(e) => {
                      if (typeof item?.onClick === "function") item?.onClick(e);
                    }}
                    className={`${styles.anchor} ${isActive ? styles.active : ""}`}
                  >
                    {iconUrl && (
                      <span className={styles.icon}>
                        <ImageKit src={iconUrl} alt="bottom navigation icon" height={20} width={20} />
                      </span>
                    )}
                    {iconVector}
                    {label}
                  </NextLink>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export default BottomNavigation;
